﻿import { AppControllerBase } from './AppControllerBase';
import { App } from '../App';

export class Wallet {
    public name:string;
    public address:string;
}
export class Token {
    public symbol:string;
    public name:string;
    public address:string;
    public decimal:number;
}
export class Config {
    public wallets:Wallet[];
    public tokens:Token[];
}

export class WalletControllerBase extends AppControllerBase
{
    private _wallets:Wallet[]=[];
    private _tokens:Token[]=[];

    constructor(app: App)
    {
        super(app);
    }

    public initialize()
    {
        const jsonWallets = localStorage.getItem("wallets");
        if (!jsonWallets) return;
        const wallets = JSON.parse(jsonWallets);
        for(const wallet of wallets) this._wallets.push(wallet);

        const jsonTokens = localStorage.getItem("tokens");
        if (!jsonTokens) return;
        const tokens = JSON.parse(jsonTokens);
        for(const token of tokens) this._tokens.push(token);
    }

    public addWallet(wallet:Wallet)
    {
        this._wallets.push(wallet);
        this._updateDB();
    }

    public removeWallet(address:string)
    {
        const withoutX = this._wallets.filter(item => item.address !== address);
        this._wallets=withoutX;
        this._updateDB();
    }

    public getWallets()
    {
        return this._wallets.slice();
    }

    public addToken(token:Token)
    {
        if (this.hasToken(token.address)) return;
        this._tokens.push(token);
        this._updateDB();
    }

    public removeToken(address:string)
    {
        const withoutX = this._tokens.filter(item => item.address !== address);
        this._tokens=withoutX;
        this._updateDB();
    }
    
    public hasToken(address:string)
    {
        const token = this._tokens.find(item => item.address === address);
        if (token) return true;
        return false;
    }
    public getTokens()
    {
        return this._tokens.slice();
    }

    private _updateDB()
    {
        localStorage.setItem("wallets",JSON.stringify(this._wallets));
        localStorage.setItem("tokens",JSON.stringify(this._tokens));
    }

    public exportConfig()
    {
        const config = new Config();
        config.tokens = this.getTokens();
        config.wallets = this.getWallets();
        const configText = JSON.stringify(config, null, 2); 
        const blob = new Blob([configText], { type: 'text/plain;charset=utf-8' });

        // Создаём ссылку для скачивания
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'config.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    public importConfigAsync() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.txt';
        let resolveFunc;
        const promise = new Promise((resolve)=>{
            resolveFunc=resolve;
        });

        input.onchange = (event: Event) => {
            const target = event.target as HTMLInputElement;
            if (!target.files?.length) return;

            const file = target.files[0];
            const reader = new FileReader();

            reader.onload = (e: ProgressEvent<FileReader>) => {
                const text = e.target?.result as string;
                try {
                    const parsed = JSON.parse(text);

                    // Теперь аккуратно маппим в экземпляры классов
                    const newConfig = new Config();
                    newConfig.wallets = (parsed.wallets || []).map((w: any) => Object.assign(new Wallet(), w));
                    newConfig.tokens = (parsed.tokens || []).map((t: any) => Object.assign(new Token(), t));

                    if (newConfig.wallets) this._wallets = newConfig.wallets;
                    if (newConfig.tokens) this._tokens = newConfig.tokens;
                    this._updateDB();
                } catch (err) {
                    console.error('Ошибка при парсинге конфига:', err);
                }
                resolveFunc();
            };

            reader.readAsText(file);
        };

        input.click();

        return promise;
    }
}